var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['base-button',{'disabled': _vm.disabled},{'focus': _vm.focus}],style:([
                {'backgroundColor': _vm.background},
                {'color': _vm.color},
                {'padding': _vm.padding},
                {'font-size': _vm.size+'px'},
                {'gap': _vm.gap+'px'},
                {'min-height': _vm.minHeight+'px'},
                {'min-width': _vm.minWidth+'px'},
             ]),attrs:{"data-text":_vm.searchLoaderStatus ? '' : _vm.localizeList.noSvgSearch},on:{"click":function($event){return _vm.click($event)}}},[_c('div',{staticClass:"hover-effect"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }